const PRODUCT_IMAGE_ASPECT_RATIOS = {
  "aspect-square": "1 / 1",
  "aspect-[4/3]": "4 / 3",
  "aspect-[16/9]": "16 / 9",
  "aspect-[3/4]": "3 / 4",
  "aspect-auto": "1 / 1",
};

const VALID_OBJECT_FITS = new Set([
  "contain",
  "cover",
  "fill",
  "none",
  "scale-down",
]);

export const getProductImagePresentation = (customization = {}) => {
  const normalizedFit = String(customization.product_image_fit || "cover").replace(
    /^object-/,
    "",
  );

  return {
    aspectRatio:
      PRODUCT_IMAGE_ASPECT_RATIOS[customization.product_image_ratio] || "1 / 1",
    objectFit: VALID_OBJECT_FITS.has(normalizedFit) ? normalizedFit : "cover",
  };
};
